import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { APP_NAME, BRAND_LOGO } from "@/lib/brand";
import { AlertTriangle, ArrowLeft } from "lucide-react";

export default function LegalPage({ kind = "privacy" }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/legal/policy").then((r) => setData(r.data)).catch(() => {}); }, []);
  const doc = data ? data[kind] : null;
  const title = kind === "privacy" ? "Privacy Policy" : "Terms of Use";

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <img src={BRAND_LOGO} alt={APP_NAME} className="h-7 w-auto object-contain" />
          <Link to="/login" className="text-sm text-[#2563EB] hover:underline inline-flex items-center gap-1" data-testid="legal-back-link"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-10" data-testid={`legal-page-${kind}`}>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        {doc && (
          <p className="text-xs text-slate-500 mt-1">Version {doc.version}{doc.effective_date ? ` · Effective ${doc.effective_date}` : ""}</p>
        )}
        {data?.is_draft && (
          <div className="mt-4 flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="legal-draft-banner">
            <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
            <span>Draft template — this document must be reviewed and finalised by legal counsel before any external commercial use. Company details are configured by the platform owner.</span>
          </div>
        )}
        <div className="mt-6 flex gap-4 text-sm">
          <Link to="/privacy" className={`hover:underline ${kind === "privacy" ? "font-semibold text-slate-900" : "text-slate-500"}`}>Privacy Policy</Link>
          <Link to="/terms" className={`hover:underline ${kind === "terms" ? "font-semibold text-slate-900" : "text-slate-500"}`}>Terms of Use</Link>
        </div>
        <div className="mt-6 space-y-5">
          {!doc && <p className="text-slate-500">Loading…</p>}
          {doc?.sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-base font-semibold text-slate-900">{i + 1}. {s.title}</h2>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed whitespace-pre-wrap">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
